import React, { useEffect, useState } from "react";
import "./news.scss";
import Slider from "react-slick";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const News = () => {
  const { t } = useTranslation();
  const [blogsData, setBlogsData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogs();
  }, []);

  const getBlogs = () => {
    var config = {
      method: "get",
      url: `https://blog.gems.vip/wp-json/wp/v2/posts?per_page=100`,
    };

    axios(config)
      .then(function (res) {
        // console.log("blog data: ", res);
        setBlogsData(res?.data);
      })
      .catch(function (error) {});
  };

  function removePTags(htmlString) {
    return htmlString.replace(/<\/?p>/gi, "");
  }


  return (
    <>
      <section className="news-section">
        <div className="custom-container">
          <div className="main-heading">
            <h4>{t("News1")} </h4>
            <Link to="/blog">
              {t("SeeAll")}{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M3.75 9H14.25"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 3.75L14.25 9L9 14.25"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
          <div className="bottom-cards">
            {/* <div className="single-card">
                            <div className="main-img">
                                <img src="\assets\landing\news\img1.png" alt="img" className='img-fluid' />
                            </div>
                            <p className="blog-title">[ NEWS ]</p>
                            <h6>Vel sunt quis eos explicabo quidem est neque facere voluptas nobis et veritatis voluptatem.</h6>
                            <div className="twice-text">
                                <p>Oct 01, 2024</p>
                                <a href="#">Read Now</a>
                            </div>
                        </div> */}
            {blogsData?.length > 0 ? (
              blogsData.slice(0, 4).map((item, index) => {
                const cleanText = removePTags(item?.title?.rendered);

                return (
                  <div key={index} className="single-card">
                    <div className="main-img">
                      <img
                        src={item?.uagb_featured_image_src?.medium[0]}
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                    <p className="blog-title">[ NEWS ]</p>
                    <h6 className="descriptionblog">{cleanText}</h6>
                    <div className="twice-text">
                      <p>[{moment(item?.date).format("MMMM DD, YYYY")}]</p>
                      <Link
                        to={{
                          pathname: `/blog/${item?.slug}`,
                          state: {
                            id: item?.id,
                          },
                        }}
                      >
                        {t("Btn-readnow")}
                      </Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <></>
            )}

            {/* <div className="single-card">
                            <div className="main-img">
                                <img src="\assets\landing\news\img3.png" alt="img" className='img-fluid' />
                            </div>
                            <p className="blog-title">[ ANNOUNCEMENT ]</p>
                            <h6>Vel sunt quis eos explicabo quidem est neque facere voluptas nobis et veritatis voluptatem.</h6>
                            <div className="twice-text">
                                <p>Oct 01, 2024</p>
                                <a href="#">Read Now</a>
                            </div>
                        </div>
                        <div className="single-card">
                            <div className="main-img">
                                <img src="\assets\landing\news\img4.png" alt="img" className='img-fluid' />
                            </div>
                            <p className="blog-title">[ UPDATE ]</p>
                            <h6>Vel sunt quis eos explicabo quidem est neque facere voluptas nobis et veritatis voluptatem.</h6>
                            <div className="twice-text">
                                <p>Oct 01, 2024</p>
                                <a href="#">Read Now</a>
                            </div>
                        </div> */}
          </div>
        
        </div>
      </section>
    </>
  );
};

export default News;
